<template>
    <LayoutForm>
        <div v-if="!isLoading" class="sector-edit">
            <h1>Edit Sector</h1>
            <div class="sector-edit__wrapper">
                <form class="form" @submit.prevent="submit" novalidate>
                    <ValidationAlert :errorList="formErrors"/>
                    <div class="form__group">
                        <FormControlSector
                            label="Parent Sector (if applicable)"
                            name="sectors"
                            v-model="formData.parent_sector"
                            :multiple="false"
                            :include-ancestors="false"
                        />
                    </div>
                    <fieldset class="sector-edit__new">
                        <div class="form__group">
                            <input
                                id="name"
                                name="name"
                                class="form__control"
                                v-model="formData.name"
                                @input="slugify_field(formData.name)"
                                placeholder="Enter a new name for this sector..."
                                v-validate
                                required
                            />
                            <label for="name" class="form__label">Name</label>
                            <div class="form__validation"></div>
                        </div>
                        <div class="form__group">
                            <input
                                id="slug"
                                name="slug"
                                class="form__control"
                                v-model="formData.slug"
                                placeholder="Enter a new slug for this sector..."
                                v-validate
                                required
                            />
                            <label for="slug" class="form__label">Slug</label>
                            <div class="form__validation"></div>
                        </div>
                        <FileUpload
                            id="image"
                            label="Image"
                            v-model="formData.image"
                            name="image"
                            :multiple="false"
                        />
                        <FormControlUser
                            name="leader"
                            v-model="formData.leader_id"
                            label="Select Sector Leader"
                        />
                        <FormControlInsightCategory
                            v-model="formData.insight_category_id"
                            name="insight_category_id"
                            label="Document folder location"
                            v-validate="'required'"
                        />
                        <div class="form__group">
                            <div class="checkbox">
                                <input id="public" type="checkbox" v-model="formData.public" />
                                <label for="public">Shown publicly on sector page?</label>
                            </div>
                        </div>
                        <div class="form__group form__group--submit">
                            <button class="btn btn--primary" v-wait:disabled='"submit"'>Save &amp; Continue</button>
                        </div>
                        <router-link class="back-button" :to="{ name: 'sector-single-view', params: { id } }">
                            Back to sector
                        </router-link>
                    </fieldset>
                </form>
            </div>
        </div>
    </LayoutForm>
</template>

<script>
import { mapGetters } from 'vuex';
import slugify from 'slugify';
import API from '@api';
import FormControlSector from '@components/Form/Control/FormControlSector';
import LayoutForm from '@components/Layout/LayoutForm';
import ValidationAlert from '@components/ValidationAlert';
import FileUpload from '@components/Form/FileUpload';
import FormControlUser from '@components/Form/Control/FormControlUser';
import FormControlInsightCategory from '@components/Form/Control/FormControlInsightCategory.vue';

//TODO: Ensure only admins can see this component.
export default {
    name: 'SectorEdit',
    components: {
        FormControlInsightCategory,
        FormControlUser,
        FileUpload,
        FormControlSector,
        ValidationAlert,
        LayoutForm,
    },
    props: {
        id: {
            type: Number,
            required: true,
        }
    },
    data() {
        return {
            isLoading: true,
            isWorking: false,
            sector_list: this.sectors || [],
            displayed: false,
            // Where the data from the forms is sent to.
            formData: {
                parent_sector: null,
                name: null,
                slug: null,
                image: null,
                insight_category_id: null,
                leader: null
            },
            formErrors: [],
        }
    },
    watch: {
        id: function(newVal, oldVal) {
            if(newVal === oldVal)
                return false;

            this.getResource(newVal);
        },
    },
    methods: {
        async getResource() {
            try {
                this.isLoading = true;
                const data = await API.getSector(this.id);

                this.formData = {
                    parent_sector: data.parent_id,
                    name: data.name,
                    slug: data.slug,
                    image: data.image ? data.image.uuid : null,
                    leader_id: data.leader ? data.leader.id : null,
                    insight_category_id: data.insightCategory ? data.insightCategory.id : null,
                    public: !!(data.public ?? false),
                }

                this.isLoading = false;
            } catch(err) {
                console.log(err);
                console.warn(`[SectorEdit.vue] ${err.message}`);
            }
        },
        async submit(e) {
            this.formErrors = [];
            this.isWorking = true;

            try {
                this.formData.slug = slugify(this.formData.slug).toLowerCase();
                await API.updateSector(this.id, this.formData);
                this.$router.push('/sectors');
            } catch(err) {
                API.mapServerValidation(err.response, this.$validator);
            }
        },
        slugify_field(text) {
            this.formData.slug = slugify(text).toLowerCase();
        },
    },
    mounted() {
        if(!this.can('createMembers')){
            this.$router.push({ name: 'sector-single-view', params: { id: this.id } });
        }
    },
    created() {
        this.getResource();
    },
    computed: {
        ...mapGetters([ 'can' ]),
    }
}
</script>

<style lang="scss" scoped>
@import '~reflex-grid/scss/includes/variables';
@import '~reflex-grid/scss/includes/mixins';
@import '~@/theme/_variables.scss';
@import '~@/mixins/_class.scss';
@import '~@/theme/_extenables.scss';

.back-button {
    text-align: center;
    display: block;
}
</style>

